import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import ReactTooltip from "react-tooltip";
import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import { catalogPhaseClean, cleanSearchingCatalogPhasesPaginated } from "../../app/actions/catalogPhaseActions";
import DisplayNameAndRole from "./DisplayNameAndRole";

const NavbarIconsCatalogPhases = ({ page }) => {
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

    const { isUserAuthenticated } = useSelector((state) => state.auth);

  const [activeIcon, setActiveIcon] = useState(null);

  const handleActiveIcon = (icon) => {
    
    if (icon === "new") {
      
      trackEvent({ component: "NewCatalogPhases", event: "NewCatalogPhases-Clicked" });
    } else if (icon === "list") {
      
      trackEvent({ component: "ListCatalogPhases", event: "ListCatalogPhases-Clicked" });
      dispatch(cleanSearchingCatalogPhasesPaginated());
    }

    dispatch(catalogPhaseClean());
    setActiveIcon(icon);
  };

  const iconActiveStyle = (icon) => {
    if (activeIcon === icon) {
      return "icon-d-flex active";
    } else {
      return "icon-d-flex";
    }
  };

  return (
    <div className="d-flex justify-content-between align-items-center flex-nowrap gradient-custom-sky custom-nav-height">
      {isUserAuthenticated && (
        <DisplayNameAndRole />
      )}
      {page === "listCatalogPhases" && (
        <Link
          data-tip
          data-for="newCatalogPhasesTip"
          to="/admin-phase/new-phase"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("new")}
        >
          <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "newCatalogPhases" && (
        <Link
          data-tip
          data-for="listCatalogPhasesTip"
          to="/admin-phase/"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("list")}
        >
          <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "editCatalogPhases" && (
        <div className="navbar-module-actions">
          <Link
            data-tip
            data-for="listCatalogPhasesTip"
            to="/admin-phase/"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("list")}
          >
            <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
          </Link>
          <Link
            data-tip
            data-for="newCatalogPhasesTip"
            to="/admin-phase/new-phase"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("new")}
          >
            <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
          </Link>
        </div>
      )}

      <ReactTooltip id="newCatalogPhasesTip" place="left" effect="solid">
        {t("admin-phase.page.register")}
      </ReactTooltip>
      <ReactTooltip id="listCatalogPhasesTip" place="left" effect="solid">
        {t("admin-phase.page.list")}
      </ReactTooltip>
    </div>
  );
};

export default NavbarIconsCatalogPhases;
